<button class="facebook-button" (click)="facebookLogin()" type="button"><span>Login</span> with<span>Facebook</span><svg class="icon"><use xlink:href="#facebook-square"></use></svg></button>


// WEBPACK FOOTER //
// ./src/components/+utils/facebook_login/facebook_login.pug